import React, {Component} from 'react';
import {Navigate} from 'react-router-dom';
import {LayoutSidebar} from "../../Layout";
import {EconomiaPage} from "./economia/EconomiaPage";
import {useFicha21} from "../../context/UserModulesContext";
import {withRouterParams} from "../../utils/withRouterParams";

// Guard de /client/:id/economia (Economía del cliente, UX 2.1). Dos condiciones: la ficha 2.1 (en
// el clásico no existe la pantalla) y el módulo de la suscripción. Sin cualquiera de las dos, a la
// ficha del cliente: la ruta no revela nada que la agencia no tenga.
//
// Hasta que llegan los módulos no se decide nada (mismo patrón que ClientLines): redirigir con los
// flags todavía en false rebotaría a quien sí tiene el módulo.
function EconomiaGuard({clientId}) {
    const {ficha21, clientEconomicsEnabled, loaded} = useFicha21();

    if (!loaded) return null;
    if (!ficha21 || !clientEconomicsEnabled) return <Navigate to={`/client/${clientId}`} replace/>;

    // `key` = el cliente: el selector del topbar navega de `/client/5/economia` a `/client/7/...`
    // reusando el elemento, y el formulario de uno no puede sobrevivir en el otro.
    return <EconomiaPage key={clientId} clientId={clientId}/>;
}

class ClientEconomiaComponent extends Component {
    render() {
        return (
            <div className="app-content">
                <LayoutSidebar/>
                <EconomiaGuard clientId={this.props.match.params.id}/>
            </div>
        );
    }
}

export default withRouterParams(ClientEconomiaComponent);
